import GroupButtons from "../../../ui/button/groupButtons";
import BaseStep from "./baseStep";
import { EDealRequestCommunicationType } from "./types";

interface ICommunicateStep {
  handlePrevStep: () => void;
  handleNexStep: () => void;
  onChange: (data: EDealRequestCommunicationType, key: "communicationType") => void;
  isNextStepDisabled: boolean;
  data: EDealRequestCommunicationType | null;
}

const CommunicateStep = ({
  handlePrevStep,
  handleNexStep,
  onChange,
  isNextStepDisabled,
  data,
}: ICommunicateStep) => {
  const handleChange = (data: EDealRequestCommunicationType) => {
    onChange(data, "communicationType");
  };

  return (
    <BaseStep
      prevStep={handlePrevStep}
      nextStep={handleNexStep}
      isNextStepDisabled={isNextStepDisabled}
      text="Выбирите форму связи:"
    >
      <GroupButtons
        data={[
          {
            onClick: () => handleChange(EDealRequestCommunicationType.Phone),
            label: "Позвонить",
            variant:
              data === EDealRequestCommunicationType.Phone
                ? "dark"
                : "lightDark",
          },
          {
            onClick: () =>
              handleChange(EDealRequestCommunicationType.Messenger),
            label: "Написать",
            variant:
              data === EDealRequestCommunicationType.Messenger
                ? "dark"
                : "lightDark",
          },
        ]}
      />
    </BaseStep>
  );
};

export default CommunicateStep;
